module.exports = __webpack_public_path__ + "static/media/Call.32a08477.png";